// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__25-CC","inputWrap":"Table_inputWrap__ilBL8","col":"Table_col__24Kae","bmiTooltip":"Table_bmiTooltip__33qhB"};